class EventEmitter {
  constructor() {
    this.events = {};
    console.log('EventEmitter created');
  }

  on(event, callback) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);
    console.log(`EventEmitter: Listener added for '${event}'. Total listeners: ${this.events[event].length}`);
  }

  off(event, callback) {
    if (!this.events[event]) return;
    this.events[event] = this.events[event].filter(cb => cb !== callback);
    console.log(`EventEmitter: Listener removed for '${event}'. Remaining listeners: ${this.events[event].length}`);
  }

  emit(event, data) {
    console.log(`EventEmitter: Emitting '${event}' with data:`, data);
    if (!this.events[event]) {
      console.log(`EventEmitter: No listeners for '${event}'`);
      return;
    }
    console.log(`EventEmitter: Calling ${this.events[event].length} listeners for '${event}'`);
    this.events[event].forEach((callback, index) => {
      try {
        callback(data);
        console.log(`EventEmitter: Listener ${index + 1} for '${event}' executed successfully`);
      } catch (error) {
        console.error(`EventEmitter: Error in listener ${index + 1} for '${event}':`, error);
      }
    });
  }
}

// Create a global instance
const eventEmitter = new EventEmitter();

export default eventEmitter; 